import axios from "axios";
import dataConstant from "../constants/dataConstants";
import urlConstant from "../constants/urlConstants";

export const refreshAccessToken = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken") ?? "";
    const refreshToken = localStorage.getItem("refreshToken") ?? "";
    const windowId = localStorage.getItem("windowId") ?? "";

    const response = await axios.post(urlConstant.Login.RefreshToken, {
      accessToken,
      refreshToken,
      windowId,
    });

    if (
      !response.data ||
      response.data.status !== dataConstant.APIStatus.Success ||
      !response.data.data
    ) {
      throw new Error("Invalid refresh response");
    }

    const { accessToken: newAccessToken, refreshToken: newRefreshToken } =
      response.data.data;

    localStorage.setItem("accessToken", newAccessToken);
    localStorage.setItem("refreshToken", newRefreshToken);

    return newAccessToken;
  } catch (error) {
    localStorage.clear();
    window.location.href = "/login";
    throw error;
  }
};